import React from 'react';
import { Zap, Shield } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
import { Countdown } from '../ui/Countdown';
const CHECKOUT_URL = 'https://polonia.recursopack.com/cart/41012708802609:1';
export function FinalCTA() {
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-107">
      <div className="max-w-3xl mx-auto text-center" data-id="element-108">
        <div className="space-y-4 md:space-y-5 text-white mb-8 md:mb-10" data-id="element-109">
          <p className="text-lg md:text-2xl leading-relaxed" data-id="element-110">
            Każdy tydzień bez systemu to kolejna niedziela przy laptopie.
          </p>
          <p className="text-lg md:text-2xl leading-relaxed" data-id="element-111">
            Kolejne zajęcia bez planu.
          </p>
          <p className="text-lg md:text-2xl leading-relaxed" data-id="element-112">
            Kolejny rodzic bez odpowiedzi.
          </p>
          <p className="text-2xl md:text-4xl font-display font-bold pt-3" style={{
          color: '#FFD700'
        }} data-id="element-113">
            Teraz masz wybór.
          </p>
        </div>

        <div className="flex flex-col items-center gap-5" data-id="element-114">
          <a href={CHECKOUT_URL} className="w-full sm:w-auto flex justify-center" data-id="element-115">
            <CTAButton size="large" className="w-full sm:w-auto" data-id="element-116">
              🏐 TAK! Chcę gotowy plan na 40 tygodni — 73 ZŁ
            </CTAButton>
          </a>

          <Countdown data-id="element-117" />

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-[#9BA3B5] mt-2" data-id="element-118">
            <span className="flex items-center gap-1" data-id="element-119">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-120" />
              Natychmiastowy dostęp
            </span>
            <span className="flex items-center gap-1" data-id="element-121">
              <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-122" />
              Gwarancja 7 dni
            </span>
          </div>
        </div>
      </div>
    </section>;
}